export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-05.aaff4cca.jpg";